<template>
  <nav class="navbar flex-between flex-align-center" :style="style" :class="{color: color}">
    <a class="navbar-brand logo-image hidden-xs-only" href="/"><img src="../../assets/images/logo.png" alt="alternative"></a>
    <a class="navbar-brand logo-image hidden-sm-and-up" href="/"><img src="../../assets/images/logo-xs.png" alt="alternative"></a>
    <ul class="flex navbar-nav hidden-xs-only">
      <li class="nav-item active-text">
        <router-link to="/">
         <p class="nav-item-title">主页</p>
        </router-link>
      </li>
      <li class="nav-item active-text">
        <router-link to="/price">
         <p class="nav-item-title">价格</p>
        </router-link>
      </li>
      <li class="nav-item active-text">
        <router-link to="/news">
         <p class="nav-item-title">资讯</p>
        </router-link>
      </li>
      <!-- <li class="nav-item active-text">
        <router-link to="/ximi">
         <p class="nav-item-title">西米工具箱</p>
        </router-link>
      </li> -->
      <li class="nav-item active-text">
        <el-dropdown >
          <p class="nav-item-title" >帮助</p>
          <template #dropdown>
            <el-dropdown-menu class="nav-dropdown-menu">
              <el-dropdown-item>
                <a target="_blank" href="https://renderg.feishu.cn/file/QK61bTF4UoYa0rx7bBUclb4DnNe?from=from_copylink">动画</a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a target="_blank" href="https://renderg.feishu.cn/wiki/space/7353462613781233667?ccm_open_type=lark_wiki_spaceLink&open_tab_from=wiki_home">效果图</a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </li>
      <li class="nav-item active-text">
        <el-dropdown >
          <p class="nav-item-title">登录</p>
          <template #dropdown>
            <el-dropdown-menu class="nav-dropdown-menu">
              <el-dropdown-item>
                <a target="_blank" href="https://x.rendercool.com/login#/login">动画</a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a target="_blank" href="https://s.rendercool.com/#/login">效果图</a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </li>
      <li class="active-text">
        <el-dropdown>
          <p class="nav-item-title">注册</p>
          <template #dropdown>
            <el-dropdown-menu class="nav-dropdown-menu">
              <el-dropdown-item>
                <a target="_blank" href="https://x.rendercool.com/login#/register?flag=register">动画</a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a target="_blank" href="https://s.rendercool.com/#/register?flag=register">效果图</a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </li>
      <li class="download-client">
        <el-dropdown>
          <p class="nav-item-title">下载客户端</p>
          <template #dropdown>
            <el-dropdown-menu class="nav-dropdown-menu">
              <el-dropdown-item>
                <a :href="download808">动画</a>
              </el-dropdown-item>
              <el-dropdown-item>
                 <a :href="download809">效果图</a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </li>
    </ul>
    <div class="more hidden-sm-and-up">
      <div class="nav-icon flex-align-center flex-center" @click="minDrawer = true">
        <img src="../../assets/images/nav-icon.png" alt="">
      </div>
      <el-drawer
        class="hidden-sm-and-up"
        custom-class="drawer-box"
        size="38.4%"
        :visible.sync="minDrawer"
        :modal-append-to-body='false'
        :show-close='false'>
        <div class="drawer-box">
          <el-menu 
            class="el-menu-vertical" 
            >
            <el-menu-item>
              <a target="_blank" href="https://s.rendercool.com/#/login">
                <span slot="title">登录</span>
              </a>
            </el-menu-item>
            <el-menu-item>
              <a target="_blank" href="https://s.rendercool.com/#/register?flag=register">
                <span slot="title">注册</span>
              </a>
            </el-menu-item>
            <!-- <el-menu-item>
              <a :href="downloadClient">
                <span slot="title">下载客户端</span>
              </a>
            </el-menu-item> -->
          </el-menu>
        </div>
      </el-drawer>
    </div>
  </nav>
</template>

<script>
import api from '../../assets/js/api'
export default {
  data() {
    return {
      style: {
        backgroundColor: '',
        marginTop: '',
      },
      color: false,
      minDrawer: false,
      download808: '',
      download809: '',
      
    }
  },
  mounted () {
    window.addEventListener("scroll", this.handleScroll);
  },
  created() {
    this.getType(810)
    this.getType(10809)
  },
  methods: {
    // 向下滚动，头部背景色变化
    handleScroll () {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // let offsetTop = document.querySelector(".header").offsetTop;
      //设置背景颜色的透明度
      if (scrollTop) {
        this.style.marginTop = 0
        this.style.backgroundColor = `rgba(0, 0, 0,${scrollTop / (scrollTop + 80)})`;
        this.color = true;
      } else if (scrollTop == 0) {
        this.style.backgroundColor = "transparent";
        this.style.marginTop = "";
        this.color = false;
      }
    },
    // 下载客户端
    getType(type) {
      api.getVersion(type).then((res) => {
        if (type == 810) {
          this.download808 = res.download_url
        } else {
          this.download809 = res.download_url
        }
      })
    }
  },
}
</script>

<style >
.nav-dropdown-menu.el-dropdown-menu {
  background-color: transparent;
  border: none;
}

.nav-dropdown-menu .el-dropdown-menu__item {
  color: #b3b3b3;
  font-size: 14px;
  padding: 0 20px;
  height: 40px;
}

.nav-dropdown-menu .el-dropdown-menu__item:focus,
.nav-dropdown-menu .el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: transparent;
  color: #fff;
}

.nav-dropdown-menu.el-popper[x-placement^=bottom] .popper__arrow {
  border-bottom-color: transparent
}
.nav-dropdown-menu.el-popper[x-placement^=bottom] .popper__arrow::after {

  border-bottom-color: transparent
}
</style>